// --------------------------------------------------------
// src/models/author.model.js
//
// Create and manage an Author Model object
//
// --------------------------------------------------------
"use strict";

const AuthorModel = Backbone.Model.extend({

  // The default values for the Author Model
  defaults: {
    id    : null,
    name  : null
  }

});
